import React from "react";
import {
  HeroSection,
  CategoriesSection,
  FeaturedProducts,
  SpecialOffers,
  NewsletterSubscription,
  ToyVideos,
  InstagramSection,
  GoogleReviewsSection,
  ContactSection,
} from "../components";
import { Product, Category, SpecialOffer, StoreInfo } from "../types";
import { getEffectiveFeatureFlags } from "../utils/featureFlags";

interface HomePageProps {
  categories: Category[];
  featuredProducts: Product[];
  specialOffers: SpecialOffer[];
  storeInfo: StoreInfo;
}

export const HomePage: React.FC<HomePageProps> = ({
  categories,
  featuredProducts,
  specialOffers,
  storeInfo,
}) => {
  // Get feature flags
  const featureFlags = getEffectiveFeatureFlags();

  // Show only top 6 featured products on homepage
  const topProducts = featuredProducts.slice(0, 6);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <HeroSection storeInfo={storeInfo} />

      {/* Categories Section */}
      <CategoriesSection categories={categories} />

      {/* Featured Products - Only show if feature flag is enabled */}
      {featureFlags.showProducts && <FeaturedProducts products={topProducts} />}

      {/* Special Offers - Only show if feature flag is enabled */}
      {featureFlags.showOffers && <SpecialOffers offers={specialOffers} />}

      {/* Newsletter Subscription - Only show if feature flag is enabled */}
      {featureFlags.showNewsletter && <NewsletterSubscription />}

      {/* Toy Videos - Only show if feature flag is enabled */}
      {featureFlags.showVideos && <ToyVideos />}

      {/* Instagram Section - Always show, but posts controlled by feature flag */}
      <InstagramSection />

      {/* Google Reviews - Only show if feature flag is enabled */}
      {featureFlags.showGoogleReviews && <GoogleReviewsSection />}

      {/* Contact Section */}
      <ContactSection storeInfo={storeInfo} />
    </div>
  );
};

export default HomePage;
